import React from "react";
import { renderRichText, storyblokEditable } from "@storyblok/react";
import { ArticleContentModel } from "./ArticleContentModel";
import YouTube from "react-youtube";

import "./ArticleContent.css";
import Utils from "../../core/Utils/Utils";

const ArticleContent: React.FC<{ blok: ArticleContentModel }> = ({ blok }) => {
  const isVideo = blok.media?.filename?.endsWith(".mp4");
  const isyoutube = blok.media?.filename?.startsWith("https://www.youtube.com");
  const videoId = blok.media?.filename?.split("v=")[1]?.split("&")[0];

  const hasImage = blok.media?.filename ? true : false;
  const classHasImage = hasImage ? "has-image" : "";
  const bodyHTML = renderRichText(blok.body) || "";

  const opts = {
    playerVars: {
      autoplay: 1,
      loop: 1,
      mute: 1,
    },
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`article-container ${classHasImage} ${blok.displayImage}`}
    >
      {blok.contentTitle && (
        <div className="content-title">
          <span>{blok.contentTitle}</span>
        </div>
      )}
      <div className="article-content">
        <div className="article-content-text">
          <div dangerouslySetInnerHTML={{ __html: bodyHTML }}></div>
        </div>
        <div className="article-content-immage">
          {isVideo && (
            <video
              autoPlay
              loop
              muted
              playsInline
              src={Utils.getCacheUrl(blok.media?.filename)}
              data-object-fit="cover"
              onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
            ></video>
          )}
          {isyoutube && videoId && <YouTube videoId={videoId} opts={opts} />}
          {!isVideo && !isyoutube && blok.media?.filename && (
            <img
              src={Utils.getCacheUrl(blok.media.filename)}
              alt=""
              onError={(e) => Utils.handleImageError(e, blok.media.filename)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ArticleContent;
